import { isNil, isNotNil } from "./utils";

export function emptyElement(element: Element): void {
	while (element.firstChild) {
		element.removeChild(element.firstChild);
	}
}

export function moveChildren(from: Element, to: Element) {
	while(from.firstChild) {
		to.appendChild(from.firstChild);
	}
}

export function openFileExplorer(
	contentTypes?: readonly string[],
	isMultiple: boolean = false
): Promise<TryResult<readonly File[]>> {
	return new Promise(
		(resolve) => {
			const fileInput = document.createElement("input");
			fileInput.type = "file";
			fileInput.accept = (contentTypes ?? []).join(",");
			fileInput.multiple= isMultiple;

			fileInput.click();

			function changeHandler(e: Event): void {
				fileInput.removeEventListener("cancel", cancelHandler);

				const input = e.target as HTMLInputElement;
				const files: FileList | null = input.files;

				if (isNil(files)
					|| (!isMultiple && files.length !== 1)
				) {
					resolve({
						wasSuccessful: false
					});
					return;
				}

				resolve({
					wasSuccessful: true,
					result: Array.from(files)
				});
			}

			function cancelHandler(): void {
				fileInput.removeEventListener("change", changeHandler);

				resolve({
					wasSuccessful: false
				});
			}

			fileInput.addEventListener(
				"change",
				changeHandler,
				{ once: true }
			);

			fileInput.addEventListener(
				"cancel",
				cancelHandler,
				{ once: true }
			);
		}
	);
}

export function clearFocus() {
	if (document.activeElement instanceof HTMLElement) {
		document.activeElement.blur();
	}
}

export function calculateAmountOfListItemThatFitInTheContainer(
	container: HTMLElement,
	counterElement: HTMLElement | null,
	containerWidth: number,
	totalAmountOfLists: number
): number {
	const listItemsWidth: readonly number[] = Array.from(
		container.querySelectorAll(":scope > li")
	)
		.filter(el => el !== counterElement)
		.map(el => (el as HTMLLIElement).offsetWidth);

	const listItemsTotalWidth: number = listItemsWidth.reduce((a, b) => a + b, 0);
	if (listItemsTotalWidth <= containerWidth) {
		return totalAmountOfLists;
	}

	let elementsWidthBeforeHiding: number = isNotNil(counterElement)
		? counterElement.offsetWidth
		: 0;

	for (let i = 0; i < listItemsWidth.length; i++) {
		if (elementsWidthBeforeHiding + listItemsWidth[i] <= containerWidth) {
			elementsWidthBeforeHiding += listItemsWidth[i];
		} else {
			return i;
		}
	}

	return totalAmountOfLists;
}

export function isTouchEvent(event: unknown): event is TouchEvent {
	// Not all browsers have the TouchEvent set when the display is not touch capable.
	// At time of writing this is Desktop Firefox and MacOs Safari
	return window.TouchEvent && event instanceof TouchEvent;
}

export function reflow(element: HTMLElement | nil): void {
	// This is for to force a repaint,
	// which is necessary in order to transition styles when adding a class name.
	// Was taken from here:
	// https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js
	// eslint-disable-next-line @typescript-eslint/no-unused-expressions
	element && element.scrollTop;
}
